import PoetTitle from './PoetAllInfoTitle.jsx';

import 'typeface-roboto';
import './title-media.scss';

export default PoetTitle;
